import { httpClient } from '@/lib/http-client'

export const settingsApi = {
    getSMTPSettings: () => httpClient.get('/settings/smtp'),
    updateSMTPSettings: (data: any) => httpClient.put('/settings/smtp', data),
    testSMTPConnection: (data: any) => httpClient.post('/settings/smtp/test', data),

    getAISettings: () => httpClient.get('/settings/ai'),
    updateAISettings: (data: any) => httpClient.put('/settings/ai', data),
    testAIConnection: (data: any) => httpClient.post('/settings/ai/test', data),
    getAIProviders: () => httpClient.get('/settings/ai/providers'),
    getAIModels: (provider: string) => httpClient.get(`/settings/ai/providers/${provider}/models`),
}
